import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Lista.css';
import {Col, Button } from 'react-materialize';
import { reArrangeData } from './Data.js';


class Lista extends Component {

  render() {
    const {indicador, order} = this.props
    return (
      <div>
        <Col l={5} m={6} s={12} className="lista">
          <h1 className="titulo"> Indicadores de Saúde - {indicador} </h1>
          <div className="margem">
            {reArrangeData(this.props.usuarios, order, indicador).map((u, index) => {
              if(indicador === 'IMC'){
                if(u.IMC >= 30){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo obeso"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.IMC)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.IMC >= 25 && u.IMC <= 30){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo sobrepeso"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.IMC)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.IMC >= 18.5 && u.IMC < 25){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo normal"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.IMC)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else{
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo abaixo"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.IMC)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }
              } else if(indicador === 'Peso'){
                if(u.peso < 40){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo SLeve"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                } else if(u.peso < 50){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo leve"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.peso < 60){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo LMedio"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.peso < 70){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo medio"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.peso < 80){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo PMedio"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else if(u.peso < 90){
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo pesado"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }else{
                  return(
                    <div key={index} className="sombra">
                      <ul className="nome">
                        <div style={{flexDirection: 'row', display: 'flex'}} >
                          <div className="cubo SPesado"></div>
                          <Link style={{marginLeft: 5}} to={`/home/jogador/${u.id}`}>{u.nome} </Link>
                        </div>
                        <span className="right-align">{Math.floor(u.peso)}</span>
                      </ul>
                      <div className="divider"></div>
                    </div>
                  )
                }
              }
            })}
          </div>
        </Col>
      </div>
    );
  }
}

export default Lista;



// WEBPACK FOOTER //
// ./src/components/Lista.js